"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _HubAI = require("@insided/shared/modules/HubAI");

var _Reply = _interopRequireDefault(require("./Reply"));

var _classnames = _interopRequireDefault(require("classnames"));

var _SubtleButton = _interopRequireDefault(require("@insided/shared/uikit/SubtleButton"));

var _AddCircle = _interopRequireDefault(require("@insided/destination/icons/AddCircle"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function getTranslatedReply(currentReply, translatedReplies) {
  var replyId = currentReply.id;

  if (translatedReplies[replyId]) {
    return translatedReplies[replyId];
  }

  return currentReply.content;
}

var ThreadedReplies = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ThreadedReplies, _Component);

  var _super = _createSuper(ThreadedReplies);

  function ThreadedReplies() {
    var _this;

    (0, _classCallCheck2.default)(this, ThreadedReplies);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      loadingMoreNested: new Set(),
      loadingPreviousNested: new Set()
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleReplies", function (replyId) {
      var onToggleReplies = _this.props.onToggleReplies;

      if (onToggleReplies) {
        onToggleReplies(replyId);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isReplyExpanded", function (replyId) {
      var _expandedReplies$has;

      var expandedReplies = _this.props.expandedReplies;
      return (_expandedReplies$has = expandedReplies === null || expandedReplies === void 0 ? void 0 : expandedReplies.has(replyId)) !== null && _expandedReplies$has !== void 0 ? _expandedReplies$has : false;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadMoreNested", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(parentId, parentContentType, currentOffset) {
        var onLoadMoreNested;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                onLoadMoreNested = _this.props.onLoadMoreNested;

                _this.setState(function (prevState) {
                  return {
                    loadingMoreNested: new Set([].concat((0, _toConsumableArray2.default)(prevState.loadingMoreNested), [parentId]))
                  };
                });

                _context.prev = 2;

                if (!onLoadMoreNested) {
                  _context.next = 8;
                  break;
                }

                _context.next = 6;
                return onLoadMoreNested(parentId, parentContentType, currentOffset);

              case 6:
                _context.next = 9;
                break;

              case 8:
                console.warn('onLoadMoreNested handler not provided. ');

              case 9:
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](2);
                console.error('Failed to load more nested replies:', _context.t0);

              case 14:
                _context.prev = 14;

                _this.setState(function (prevState) {
                  var newLoadingSet = new Set(prevState.loadingMoreNested);
                  newLoadingSet.delete(parentId);
                  return {
                    loadingMoreNested: newLoadingSet
                  };
                });

                return _context.finish(14);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 11, 14, 17]]);
      }));

      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadPreviousNested", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(parentId, parentContentType, currentOffset) {
        var onLoadPreviousNested;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                onLoadPreviousNested = _this.props.onLoadPreviousNested;

                _this.setState(function (prevState) {
                  return {
                    loadingPreviousNested: new Set([].concat((0, _toConsumableArray2.default)(prevState.loadingPreviousNested), [parentId]))
                  };
                });

                _context2.prev = 2;

                if (!onLoadPreviousNested) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 6;
                return onLoadPreviousNested(parentId, parentContentType, currentOffset);

              case 6:
                _context2.next = 9;
                break;

              case 8:
                console.warn('onLoadPreviousNested handler not provided.');

              case 9:
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](2);
                console.error('Failed to load previous nested replies:', _context2.t0);

              case 14:
                _context2.prev = 14;

                _this.setState(function (prevState) {
                  var newLoadingSet = new Set(prevState.loadingPreviousNested);
                  newLoadingSet.delete(parentId);
                  return {
                    loadingPreviousNested: newLoadingSet
                  };
                });

                return _context2.finish(14);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 11, 14, 17]]);
      }));

      return function (_x4, _x5, _x6) {
        return _ref2.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(ThreadedReplies, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          replies = _this$props.replies,
          _this$props$translate = _this$props.translatedReplies,
          translatedReplies = _this$props$translate === void 0 ? [] : _this$props$translate,
          _this$props$isTransla = _this$props.isTranslationInProgress,
          isTranslationInProgress = _this$props$isTransla === void 0 ? false : _this$props$isTransla,
          authors = _this$props.authors,
          type = _this$props.type,
          currentUser = _this$props.currentUser,
          onReply = _this$props.onReply,
          topic = _this$props.topic,
          _this$props$canMarkBe = _this$props.canMarkBestAnswer,
          canMarkBestAnswer = _this$props$canMarkBe === void 0 ? false : _this$props$canMarkBe,
          attachmentCdn = _this$props.attachmentCdn,
          unlimitedEditPermission = _this$props.unlimitedEditPermission,
          disableFileAttachments = _this$props.disableFileAttachments,
          _this$props$userHasPe = _this$props.userHasPermissionToReply,
          userHasPermissionToReply = _this$props$userHasPe === void 0 ? false : _this$props$userHasPe,
          expandedReplies = _this$props.expandedReplies,
          onToggleReplies = _this$props.onToggleReplies,
          onNestedReplyAdded = _this$props.onNestedReplyAdded,
          onLikeUpdate = _this$props.onLikeUpdate,
          showPostActions = _this$props.showPostActions,
          parentReplyId = _this$props.parentReplyId,
          _this$props$displayRe = _this$props.displayReportAction,
          displayReportAction = _this$props$displayRe === void 0 ? true : _this$props$displayRe,
          _this$props$displayEx = _this$props.displayExtendedActions,
          displayExtendedActions = _this$props$displayEx === void 0 ? false : _this$props$displayEx,
          _this$props$canUserPi = _this$props.canUserPinReplies,
          canUserPinReplies = _this$props$canUserPi === void 0 ? false : _this$props$canUserPi,
          _this$props$displayPo = _this$props.displayPostStatusPill,
          displayPostStatusPill = _this$props$displayPo === void 0 ? false : _this$props$displayPo;
      var result = replies.result,
          metadata = replies.metadata;
      var isRootLevel = metadata.depthLevel === 1;
      return (0, _preact.h)("div", {
        className: isRootLevel ? 'threaded-reply-wrapper' : ''
      }, result.map(function (reply, index) {
        var _replyChildren$metada, _replyChildren$metada2;

        var replyChildren = reply === null || reply === void 0 ? void 0 : reply.children;
        var hasChildren = (replyChildren === null || replyChildren === void 0 ? void 0 : (_replyChildren$metada = replyChildren.metadata) === null || _replyChildren$metada === void 0 ? void 0 : _replyChildren$metada.totalCount) > 0;
        var isFirstChild = index === 0;
        var isLastChild = index === result.length - 1;
        var isExpanded = hasChildren ? _this2.isReplyExpanded(reply.id) : undefined;
        var translatedReply = getTranslatedReply(reply, translatedReplies);
        return (0, _preact.h)("div", {
          key: reply.id,
          id: "post".concat(reply.publicReplyId),
          className: ThreadedReplies.getReplyClassNames(isRootLevel, metadata.depthLevel, isFirstChild, isLastChild)
        }, (0, _preact.h)(_Reply.default, {
          key: "reply-".concat(reply.id, "-").concat(replyChildren === null || replyChildren === void 0 ? void 0 : (_replyChildren$metada2 = replyChildren.metadata) === null || _replyChildren$metada2 === void 0 ? void 0 : _replyChildren$metada2.totalCount),
          reply: reply,
          authors: authors,
          translatedReplyContent: translatedReply,
          displayPostStatusPill: displayPostStatusPill,
          displayReportAction: displayReportAction,
          displayExtendedActions: displayExtendedActions,
          canUserPinReplies: canUserPinReplies,
          isAllRepliesTranslationInProgress: isTranslationInProgress,
          contentType: type,
          currentUser: currentUser,
          topic: topic,
          canMarkBestAnswer: canMarkBestAnswer,
          attachmentCdn: attachmentCdn,
          unlimitedEditPermission: unlimitedEditPermission,
          disableFileAttachments: disableFileAttachments,
          depthLevel: metadata.depthLevel,
          isLastChild: isLastChild,
          userHasPermissionToReply: userHasPermissionToReply,
          hasNestedRepliesInThread: hasChildren,
          replyCount: hasChildren ? replyChildren.metadata.totalCount : undefined,
          isExpanded: isExpanded,
          onToggleReplies: hasChildren ? function () {
            return _this2.toggleReplies(reply.id);
          } : undefined,
          onNestedReplyAdded: onNestedReplyAdded,
          onLikeUpdate: onLikeUpdate,
          showPostActions: showPostActions,
          parentReplyId: parentReplyId !== null && parentReplyId !== void 0 ? parentReplyId : undefined
        }), hasChildren && isExpanded && (0, _preact.h)("div", {
          className: "threaded-replies-nested"
        }, replyChildren.metadata.hasPrevious && (0, _preact.h)("div", {
          className: "show-previous-nested-replies"
        }, (0, _preact.h)(_SubtleButton.default, {
          size: "small",
          className: "show-previous-nested-btn",
          onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
            return _regenerator.default.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    return _context3.abrupt("return", _this2.loadPreviousNested(reply.id, type, replyChildren.metadata.offset));

                  case 1:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          })),
          disabled: _this2.state.loadingPreviousNested.has(reply.id),
          startIcon: (0, _preact.h)(_AddCircle.default, {
            width: 14,
            height: 14
          }),
          title: _this2.state.loadingPreviousNested.has(reply.id) ? 'Loading...' : (0, _preact.h)(_phrase.default, {
            key: "show-previous-".concat(reply.id, "-").concat(replyChildren.metadata.offset),
            p: "threaded_replies.show_previous_replies"
          })
        })), (0, _preact.h)(ThreadedReplies, {
          replies: replyChildren,
          translatedReplies: translatedReplies,
          displayPostStatusPill: displayPostStatusPill,
          isTranslationInProgress: isTranslationInProgress,
          authors: authors,
          type: type,
          currentUser: currentUser,
          onReply: onReply,
          topic: topic,
          canMarkBestAnswer: canMarkBestAnswer,
          attachmentCdn: attachmentCdn,
          displayReportAction: displayReportAction,
          displayExtendedActions: displayExtendedActions,
          unlimitedEditPermission: unlimitedEditPermission,
          disableFileAttachments: disableFileAttachments,
          userHasPermissionToReply: userHasPermissionToReply,
          expandedReplies: expandedReplies,
          onToggleReplies: onToggleReplies,
          onLoadMoreNested: _this2.loadMoreNested,
          onLoadPreviousNested: _this2.props.onLoadPreviousNested,
          onNestedReplyAdded: onNestedReplyAdded,
          onLikeUpdate: onLikeUpdate,
          showPostActions: showPostActions,
          parentReplyId: reply.id
        }), replyChildren.metadata.hasMore && replyChildren.metadata.totalCount - replyChildren.result.length > 0 && (0, _preact.h)("div", {
          className: "show-more-nested-replies"
        }, (0, _preact.h)(_SubtleButton.default, {
          size: "small",
          className: "show-more-nested-btn",
          onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
            return _regenerator.default.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    return _context4.abrupt("return", _this2.loadMoreNested(reply.id, type, replyChildren.metadata.offset + replyChildren.result.length));

                  case 1:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          })),
          disabled: _this2.state.loadingMoreNested.has(reply.id),
          startIcon: (0, _preact.h)(_AddCircle.default, {
            width: 14,
            height: 14
          }),
          title: _this2.state.loadingMoreNested.has(reply.id) ? 'Loading...' : (0, _preact.h)(_phrase.default, {
            key: "show-more-".concat(reply.id, "-").concat(replyChildren.result.length),
            p: "threaded_replies.show_more_nested_replies",
            count: {
              n: (replyChildren.metadata.totalCount - (replyChildren.metadata.offset + replyChildren.result.length)).toString()
            }
          })
        }))));
      }));
    }
  }], [{
    key: "getReplyClassNames",
    value: function getReplyClassNames(isRootLevel, depthLevel, isFirstChild, isLastChild) {
      if (isRootLevel) return 'threaded-reply-item-wrapper';
      return (0, _classnames.default)('threaded-reply-nested', "level-".concat(depthLevel), {
        'first-child': isFirstChild
      }, {
        'last-child': isLastChild
      });
    }
  }]);
  return ThreadedReplies;
}(_preact.Component);

var _default = (0, _HubAI.withOnDemandTranslationProps)(ThreadedReplies, ['isTranslationInProgress', 'translatedReplies']);

exports.default = _default;
var cssAnchorName = 'threaded-replies';
exports.cssAnchorName = cssAnchorName;